<app-wizard-phase-header
  [phase]="tenderPhase"
  [companyName]="tenderDetails().companyName"
  [projectName]="tenderDetails().projectName"
/>

<p-tabs appTabsUnsavedReveal [value]="activeTabIndex()" (valueChange)="onTabChange($event!)">
  <p-tablist>
    <p-tab
      [value]="0"
      [appTabStatus]="mailPreviewTabStatus()"
      data-testid="rfd-wizard-mail-preview-tab"
    >
      <span>{{ 'provider.tenderWizard.mailPreview.tabTitle' | transloco }}</span>
    </p-tab>
    <p-tab
      [value]="1"
      [appTabStatus]="demonstrationAgendaTabStatus()"
      data-testid="rfd-wizard-demonstration-agenda-tab"
    >
      <span>{{ 'provider.tenderWizard.demonstrationAgenda.tabTitle' | transloco }}</span>
    </p-tab>
    @if (questionnaireInvited()) {
      <p-tab [value]="2" [appTabStatus]="decisionTabStatus()" data-testid="rfd-wizard-decision-tab">
        <span>{{ 'provider.tenderWizard.confirmation.tabTitle' | transloco }}</span>
      </p-tab>
    }
  </p-tablist>

  <p-tabpanels class="mt-6">
    <p-card>
      <p-tabpanel [value]="0">
        <app-tender-invitation-mail [tenderDetails]="tenderDetails()" (nextTab)="goToNextTab()" />
      </p-tabpanel>

      <p-tabpanel [value]="1">
        <app-tender-demonstration-agenda [tenderId]="tenderId()" />
        <div class="flex justify-end mt-4">
          @if (questionnaireInvited()) {
            <p-button
              [label]="'common.next' | transloco"
              (onClick)="goToNextTab()"
              data-testid="next-tab-button"
            />
          }
        </div>
      </p-tabpanel>
      @if (questionnaireInvited()) {
        <p-tabpanel [value]="2">
          <app-tender-decision
            [tenderDetails]="tenderDetails()"
            [tenderPhase]="tenderPhase"
            (accepted)="onTenderAccepted()"
          />
        </p-tabpanel>
      }
    </p-card>
  </p-tabpanels>
</p-tabs>
